import { Component, OnInit } from '@angular/core';
import { DevOpsAlarm, ErmDevOpsApiClientService } from 'erm-sdk';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-widget-non-sla-alarms',
  templateUrl: './non-sla-alarms-widget.component.html',
  styleUrls: ['./non-sla-alarms-widget.component.scss']
})
export class NonSlaAlarmsWidgetComponent implements OnInit {
  isLoading = false;

  redAlarms?: DevOpsAlarm[];
  greenAlarms?: DevOpsAlarm[];
  pendingAlarms?: DevOpsAlarm[];

  actions?: any[];

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService, router: Router) {
    this.actions = [
      {
        name: 'View Alarms',
        run: () => {
          const url = router.createUrlTree(['erm/alarms']);
          router.navigateByUrl(url);
        }
      }
    ];
  }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  refresh = async (): Promise<boolean> => {
    try {
      this.isLoading = true;

      const getAlarmsResponse = await this.ermDevOpsApiClient.getAlarms();
      const nonSlaAlarms = _.filter(getAlarmsResponse.body?.alarms, x => x.serviceLevel === 'NonSLA');

      this.redAlarms = _.filter(nonSlaAlarms, x => x.alarmState === 'ALARM');
      this.greenAlarms = _.filter(nonSlaAlarms, x => x.alarmState === 'OK');
      this.pendingAlarms = _.filter(nonSlaAlarms, x => x.alarmState === 'INSUFFICIENT_DATA');

      return true;
    }
    finally {
      this.isLoading = false;
    }
  }
}
